import axios from '../helpers/axios'

export const OpenTutorial = (userId: string | undefined, token: string | undefined) =>
  axios
    .post(
      `/games/tutorial/open`,
      { userId, platform: 'web' },
      {
        headers: {
          Authorization: token,
          accept: 'application/json',
        },
      },
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })

export const SkipTutorial = (userId: string | undefined, token: string | undefined) =>
  axios
    .post(
      `/games/tutorial/skip`,
      { userId, platform: 'web' },
      {
        headers: {
          Authorization: token,
          accept: 'application/json',
        },
      },
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })

export const CreateGift = (userId: string, token: string, type: string) =>
  axios
    .post(
      `/games/gift/create`,
      { userId, type },
      {
        headers: {
          Authorization: token,
          accept: 'application/json',
        },
      },
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })

export const GetListGift = (id: string, token: string) =>
  axios
    .post(
      `/games/gifts/list`,
      { userId: id },
      {
        headers: {
          Authorization: token,
          accept: 'application/json',
        },
      },
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })
